import { render, staticRenderFns } from "./WebcastYoutube.vue?vue&type=template&id=664ea72a&"
import script from "./WebcastYoutube.vue?vue&type=script&lang=js&"
export * from "./WebcastYoutube.vue?vue&type=script&lang=js&"
import style0 from "./WebcastYoutube.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WebcastYoutube.vue"
export default component.exports